import React, {useEffect, useState} from "react";
import {Col, Row} from "antd";
import _ from "lodash";
import {EquipmentTypeFilter} from "../../../_defaultComponents/FilterComponents";

const Filters = ({setCurrentPage, filters, setFilters}) => {
    const [typeId, setTypeId] = useState(filters?.typeId);

    useEffect(() => {
        setCurrentPage(1);
    }, [typeId]);

    useEffect(() => {
        const newFilters = {typeId};
        if (JSON.stringify(filters) !== JSON.stringify(newFilters)) {
            setFilters(newFilters);
        }
    }, [typeId]);

    return (
        <React.Fragment>
            <Col xs={24} sm={12} lg={6}>
                <EquipmentTypeFilter
                    value={typeId}
                    onChange={setTypeId}
                    updateStoreOptions={true}
                />
            </Col>
        </React.Fragment>
    );
};

export default Filters;
